<template>
  <div class="organization-search  pa-10">

    <title-page icon="ico-organization">
      {{ $t('organization.search-organization') }}
    </title-page>
    <v-row class="my-5">
      <v-col class="text-right">
        <v-btn :to="{name: 'organizations.add'}">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('organization.add-organization') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <search-field
            :placeholder="$t('organization.search-organization')"
            :search.sync="search"
            :options.sync="options"
            clearable
        >
        </search-field>

        <div class="filter-form">
          <v-card class="mt-6">
            <v-card-text>
              <v-row >
                <v-col cols="12" md="3">
                  <form-field
                      :label="$t('organization.organization-type')"
                      type="select"
                      :items="organizationTypes"
                      v-model="filters.type"
                      clearable
                  />
                </v-col>
                <v-col cols="12" md="3" v-if="currentUser.isZE">
                  <form-field
                      type="perimeter-select"
                      :label="$tc('organization.perimeter.perimeter', 1)"
                      v-model="filters.perimeterId"
                      clearable
                  />
                </v-col>
                <v-col cols="12" md="3"  v-if="currentUser.isZE">
                  <form-field
                      type="sub-perimeter-select"
                      :label="$tc('organization.sub-perimeter.sub-perimeter', 1)"
                      v-model="filters.subPerimeterId"
                      :perimeter-id="filters.perimeterId"
                      clearable
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <form-field
                      :label="$t('country')"
                      type="available-select"
                      input-type="country"
                      v-model="filters.country"
                      :filter="c => { return [
                          'FR', 'LU', 'BE',, 'NL',
                          //'DE', 'ES', 'IT', 'GB'
                          ].includes(c.code) }"
                      clearable
                  />
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" md="6">
                  <form-field
                      type="operator"
                      :label="$t('organization.roaming-identifier') + ' (CPO)'"
                      v-model="filters.roamingCpoId"
                      role="CPO"
                      isInternal
                      clearable
                      col-field="9"
                  />
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <form-field
                      :label="$t('organization.allow-deferred-payment')"
                      type="switch"
                      v-model="filters.allowDeferredPayment"
                      col-field="3"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>

        <filter-by-letter
            :selectedLetter="startBy"
            @update:startBy="updateStartBy"
        />
      </v-col>
    </v-row>




    <v-row no-gutters class="mt-10">
      <v-col>
        <v-data-table
            class="organization-list"
            :headers="headers"
            :items="filteredItems"
            :loading="loading"
            :options.sync="options"
            :server-items-length="total"
            @click:row="row => $router.push(toOrganization(row))"
        >
          <template #item.name="{item}">
            <router-link :to="toOrganization(item)">
              <v-icon left>{{ commonIcons().organization.type[item.type] }}</v-icon>
              <span style="font-weight: 300;">{{ item.path.substr(0, item.path.length - item.name.length) }}</span><span class="red--text">{{ item.name }}</span>
            </router-link>
          </template>

        </v-data-table>

      </v-col>
    </v-row>

  </div>
</template>

<script>
import OrganizationRepository from "@repository/OrganizationRepository";
import FilterByLetter from "@blocks/FilterByLetter.vue";

export default {
  name: 'OrganizationSearch',
  components: {FilterByLetter},
  data() {
    return {
      search: '',
      startBy: null,
      selectedItem: null,
      items: [],
      filteredItems: [],
      loading: false,
      options: null,
      total: 0,
      filters: {
        type: null,
        perimeterId: null,
        subPerimeterId: null,
        country: null,
        roamingCpoId: null,
        roamingEmspId: null,
        allowDeferredPayment: null,
      },
    }
  },
  watch: {
    search() {
      this.loadData()
    },

    options() {
      this.loadData()
    },
    startBy() {
      this.loadData();
    },
    selectedItem(val) {
      this.$router.push({name: 'organizations.detail', params: {id: val.id} })
    },
    filters: {
      handler() { this.loadData() },
      deep: true,
    },
  },

  computed: {
    organizationTypes() {
      const t = this.$t('organization.type')
      // t is an object with keys: company, group, individual
      const items = []
      for (let k in t) {
        items.push({ text: t[k], value: k })
      }
      return items
    },

    headers() {
      const headers =  [
        {text: this.$t('name'), value: "name"},
        {text: this.$t('account-number'), value: "accountNumber", width: 150},
      ]

      if(this.currentUser.isZE) {
        headers.push({text: this.$tc('organization.perimeter.perimeter'), value: "perimeter.code", width: 200})
        headers.push({text: this.$tc('organization.sub-perimeter.sub-perimeter'), value: "subPerimeter.code", width: 200})
      }

      return headers
    },
  },

  methods: {
    toOrganization(item) {
      if(this.showOrganizationDashboard) {
        return {name: 'organizations.dashboard', params: {id: item.id}}
      }
      return {name: 'organizations.detail', params: {id: item.id}}
    },

    updateStartBy(letter) {
      this.startBy = letter;
    },
    loadData() {
      this.loading = true

      let data = {
        searchText: this.search,
      }
      if (this.options.itemsPerPage > -1) {
        data.offset = (this.options.page * this.options.itemsPerPage) - this.options.itemsPerPage
      }
      data.limit = this.options.itemsPerPage


      if (this.options.sortBy.length > 0) {
        data.orderBy = this.options.sortBy[0]
      }

      if (this.options.sortDesc.length > 0) {
        data.orderDirection = this.options.sortDesc[0] ? 'desc' : 'asc'
      }
      data.startBy = this.startBy

      // Append filters if set
      if (this.filters.type) data.type = this.filters.type
      if (this.filters.perimeterId) data.perimeterId = this.filters.perimeterId
      if (this.filters.subPerimeterId) data.subPerimeterId = this.filters.subPerimeterId
      if (this.filters.country) data.country = this.filters.country
      if (this.filters.roamingCpoId) data.roamingCpoId = this.filters.roamingCpoId
      if (this.filters.roamingEmspId) data.roamingEmspId = this.filters.roamingEmspId
      if (this.filters.allowDeferredPayment !== null) data.allowDeferredPayment = this.filters.allowDeferredPayment

      OrganizationRepository.search(data, 'search-org').then(results => {
        this.total = results.total
        this.items = results.items
        this.filteredItems = this.items
        this.loading = false
      }).catch(e => {
        this.notifyError(e)
        this.loading = false
      })
    },
  }
}
</script>

<style lang="scss">
.organization-search {
  min-height: 1000px;
  .filter-form {
    .v-text-field.v-text-field--solo {
      transform: translateY(8px) !important;
    }
  }
  .organization-list {
    td, th {
      cursor: pointer;
      &.text-start {
        text-align: left !important;
      }
      a {
        text-decoration: none;
      }
    }
  }
}
</style>
